<template>
	<div class="btn__menu">
		<UiIcon
			name="menu"
			color="var(--color-icon-white-gold)"
			height="18"
			width="27"
		></UiIcon>
	</div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
	.btn__menu {
		height: 18px;
		cursor: pointer;
	}
</style>
